import { render, staticRenderFns } from "./sectionM6.vue?vue&type=template&id=470067b4&scoped=true&"
import script from "./sectionM6.vue?vue&type=script&lang=js&"
export * from "./sectionM6.vue?vue&type=script&lang=js&"
import style0 from "./sectionM6.vue?vue&type=style&index=0&id=470067b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470067b4",
  null
  
)

export default component.exports